import { graphClient } from '../graph-client'
import { GET_USER_LIVE_SETTING } from './gql'
import type { GetUserSetting } from './types'

class LiveSettingService {
  async getUserSetting({ liveId }: GetUserSetting.Input) {
    const request = await graphClient.request<GetUserSetting.Output>(
      GET_USER_LIVE_SETTING,
      {
        liveId: Number(liveId),
      },
    )

    return request?.getUserLiveSetting
  }
}

export const liveSettingService = new LiveSettingService()
